/** @format */

if ("NodeList" in window && !NodeList.prototype.forEach) {
  console.info("polyfill for IE11");
  NodeList.prototype.forEach = function (callback, thisArg) {
    thisArg = thisArg || window;
    for (let i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}

(function () {
  /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */
  // Remove empty <p> tags created by tinymce
  const paragraph = document.querySelectorAll("p") || [];
  paragraph.forEach(
    (e) => e.innerHTML.trim() === "" && e.parentNode.removeChild(e)
  );
  $(".acc-btn").click(function (e) {
    e.preventDefault();
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).next().slideToggle();
    } else {
      $(".acc-btn").removeClass("active");
      $(".tab-content").slideUp();
      $(this).addClass("active");
      $(this).next().slideToggle();
    }
  });
  $(".sym-slides").slick({
    accessibility: false,
  });




  $(".slick-slider").slick({
    prevArrow: $(".prev-1"),
    nextArrow: $(".next-1"),
  });
  
  
  


})();
